import type { QueryFilter } from '@domain/types/filters';
import { areFiltersEqual, useQueryFilters } from '@features/query-builder';

export const useSavedViewDirty = (savedFilters: QueryFilter[] | undefined, entityName: string): boolean => {
  const filters = useQueryFilters(entityName);
  if (!savedFilters) return false;
  return !areFiltersEqual(filters, savedFilters);
};
